import { render } from "./Haves.vue?vue&type=template&id=95dcd818&scoped=true&ts=true"
import script from "./Haves.vue?vue&type=script&lang=ts"
export * from "./Haves.vue?vue&type=script&lang=ts"

import "./Haves.vue?vue&type=style&index=0&id=95dcd818&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95dcd818"]])

export default __exports__